import { Loader } from "@googlemaps/js-api-loader"

export const environment = {
  production: false,
  apiUrl: 'http://localhost:8100/',
};

export const loader = new Loader({
  apiKey: 'AIzaSyCCr8shSdWxWk9ZGRakWCLxL7uFa-xtaWU',
  version: 'weekly',
  language: 'pt-BR',
  libraries: ['places'],
});

// export const API_URL: string = 'https://institucional-trigo.mac/api/';
// export const API_URL: string = "http://institucional-trigo/api/";
// export const API_URL: string = 'https://crm.grupotrigo.alphacode.mobi/api/';
export const API_URL: string = 'https://grupotrigo.alphacode.com.br/api/';

export const PASSPHRASE_AUTH = '[R&XP$L9yQMHg^W!AexZtKL8*[!mF2q3DJbd4![N,Y!?XrVU!*#P5s7k#8!iH';

export const SOFTWARE_VERSION = '0.0.1';

export const ENCRYPT = false;
